<template>
	<div v-if="person!=null" style="height: 100%;width: 100%;padding-top: 6px;">
		<Card style="width: 100%;font-size: 18px;font-weight: bold;margin-bottom: 2rem;">
			<div style="height: 30px;">
			珙县2019年基本公卫知识有奖问答成绩单
			</div>
		</Card>
		<div style="height: 12rem;text-align: center;">
			<img :src="currResult.img" style="width: %80;height: 100%;" />
		</div>
		<Row type="flex" justify="center" align="center" style="margin-bottom: 3rem;">
			<Col span="2">
			</Col>
			<Col span="20" style="font-size: 3rem;text-align: center;">
				成绩{{person.grade}}分
			</Col>
			<Col span="2">
			</Col>
		</Row>
		<Row type="flex" justify="center" align="center">
			<Col span="6">
			</Col>
			<Col span="12" >
				<Button @click="againTopic" type="info" long>{{currResult.content}}</Button>
			</Col>
			<Col span="6">
			</Col>
		</Row>
	</div>
</template>
<script>
	import remoteLoad from '@/assets/js/remoteload.js'
	export default {
		data(){
			return {
				person:sessionStorage.person?JSON.parse(sessionStorage.person):{},
				result:[
					{
						maxGrade:100,
						minGrade:100,
						content:'又来一盘',
						img:require('../../../../../../assets/image/100.jpg')
					},
					{
						maxGrade:99,
						minGrade:92,
						content:'满分冲刺',
						img:require('../../../../../../assets/image/90.jpg')
					},
					{
						maxGrade:91,
						minGrade:57,
						content:'再来一盘',
						img:require('../../../../../../assets/image/80.jpg')
					},
					{
						maxGrade:56,
						minGrade:56,
						content:'再来一盘',
						img:require('../../../../../../assets/image/59.jpg')
					},
					{
						maxGrade:55,
						minGrade:8,
						content:'再告一盘',
						img:require('../../../../../../assets/image/50.jpg')
					},
					{
						maxGrade:0,
						minGrade:0,
						content:'再告一盘',
						img:require('../../../../../../assets/image/0.jpg')
					}
				],
				currResultIndex:0
			}
		},
		beforeCreate:function(){
			Promise.all([
				remoteLoad('https://res.wx.qq.com/open/js/jweixin-1.2.0.js'),
				remoteLoad('https://res2.wx.qq.com/open/js/jweixin-1.2.0.js')
			]).then(()=>{
				this.$http.get('page/WXJsConfig?url='+window.location.href,'').then((res)=> {
					res.data.jsApiList=[
						'onMenuShareAppMessage'
					];
					res.data.debug=true;
					wx.config(res.data);
					// wx.ready(function () {      //需在用户可能点击分享按钮前就先调用
						wx.onMenuShareAppMessage({ 
							title: '参与公卫有奖问答，分享有礼', // 分享标题
							desc: '', // 分享描述
							link: localStorage.ServerUrl+'/index/main?page=Wechat/Testing', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
							imgUrl: 'http://t.cn/AiWoPKWp', // 分享图标
							success: function () {
								console.log('onMenuShareAppMessage设置成功')
							},
							error:function(){
								console.log('异常')
							}
						})
						
// 						 wx.updateTimelineShareData({ 
// 							title: '参与公卫有奖问答，分享有礼', // 分享标题
// 							link: localStorage.ServerUrl+'/index/main?page=Wechat/Testing', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
// 							imgUrl: 'http://t.cn/AiWoPKWp', // 分享图标
// 							success: function () {
// 								console.log('updateTimelineShareData设置成功')
// 							},
// 							error:function(){
// 								console.log('异常')
// 							}
// 						})
					// });
				});
			});
		},
		created:function(){
// 			if(this.person.grade==undefined){
// 				this.$router.push('/404');
// 				return ;
// 			}
			if(this.person.grade==100){
				this.currResultIndex=0;
			}else if(this.person.grade<=99&&this.person.grade>=92){
				this.currResultIndex=1;
			}else if(this.person.grade<=91&&this.person.grade>=57){
				this.currResultIndex=2;
			}else if(this.person.grade==56){
				this.currResultIndex=3;
			}else if(this.person.grade<=55&&this.person.grade>=8){
				this.currResultIndex=4;
			}else{
				this.currResultIndex=5;
			}
		},
		methods:{
			againTopic(){
				this.$router.push({name:'Topic'});
			}
		},
		computed:{
			currResult:function(){
				return this.result[this.currResultIndex];
			}
		},
		watch:{
			
		}
	}
</script>
<style>
	
</style>


// WEBPACK FOOTER //
// src/components/views/WeChat/Person/Testing/Result/index.vue